import React from "react";
import "./RewardsModal.css";

const RewardsModal = ({ open, onClose, restaurant, rewards }) => {
  if (!open) return null;
  const availablePoints =
    (restaurant?.totalEarnedPoints ?? 0) -
    (restaurant?.totalRedeemedPoints ?? 0);
  const claimableRewards = rewards?.filter(
    (item) => availablePoints >= (item.orderAmount ?? 0)
  );
  const notClaimableRewards = rewards?.filter(
    (item) => availablePoints < (item.orderAmount ?? 0)
  );
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };
  return (
    <div className="rewards-modal-overlay" onClick={handleOverlayClick}>
      <div className="rewards-modal">
        <div className="rewards-modal-header">
          <h3>Rewards for {restaurant.restaurantName}</h3>
          <button className="reward-close-button" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="rewards-modal-body">
          {/* Claimable Rewards */}
          {claimableRewards?.length > 0 && (
            <>
              <h4 className="table-heading">Claimable Rewards</h4>
              <div className="rewards-table-container">
                <table className="rewards-table">
                  <thead>
                    <tr>
                      <th>Reward</th>
                      <th>Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    {claimableRewards.map((item, index) => (
                      <tr key={index}>
                        <td data-label="Reward">{item.reward}</td>
                        <td data-label="Points" className="green-text">{item.orderAmount} pts</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {/* Not Claimable Rewards */}
          {notClaimableRewards?.length > 0 && (
            <>
              <h4 className="table-heading red-heading">
                Not Claimable Rewards
              </h4>
              <div className="rewards-table-container">
                <table className="rewards-table">
                  <thead>
                    <tr>
                      <th>Reward</th>
                      <th>Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notClaimableRewards.map((item, index) => (
                      <tr key={index}>
                        <td data-label="Reward">{item.reward}</td>
                        <td data-label="Points" className="red-text">{item.orderAmount} pts</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {(!rewards || rewards.length === 0) && (
            <p className="no-rewards">No rewards available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardsModal;